import { format } from "date-fns";

export const formatStopDate = (value: string | null): string => {
	if (!value) {
		return "Unknown";
	}
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) {
		return "Unknown";
	}
	return format(date, "MMM dd, yyyy hh:mm a");
};
